import type * as ShoppingCartItem from './ShoppingCartItem';
import { ShoppingCartItemTypeEnum } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

type DonationItemInput = {
  itemType: ShoppingCartItemTypeEnum.Donation;
  amount: number;
};

type DiscountItemInput = {
  itemType: ShoppingCartItemTypeEnum.Discount;
  details: { code: string };
};

type PresaleItemInput = {
  itemType: ShoppingCartItemTypeEnum.Presale;
  details: { code: string };
};

type TicketItemInput = {
  itemId: number;
  itemType: ShoppingCartItemTypeEnum.Ticket | ShoppingCartItemTypeEnum.SeatTicket;
  count: number;
  details?: unknown;
};

export type ShoppingCartItemInput = TicketItemInput | DonationItemInput | DiscountItemInput | PresaleItemInput;

export const getNew = (itemId: number): ShoppingCartItemInput => ({
  itemType: ShoppingCartItemTypeEnum.Ticket,
  itemId,
  count: 0,
});

export const newSeatTicket = (itemId: number): TicketItemInput => ({
  itemType: ShoppingCartItemTypeEnum.SeatTicket,
  itemId,
  count: 0,
});

export const newDonation = (amount: number): DonationItemInput => ({
  itemType: ShoppingCartItemTypeEnum.Donation,
  amount,
});

export const newDiscount = (code: string): DiscountItemInput => ({
  itemType: ShoppingCartItemTypeEnum.Discount,
  details: { code },
});

export const newPresale = (code: string): PresaleItemInput => ({
  itemType: ShoppingCartItemTypeEnum.Presale,
  details: { code },
});

export const fromShoppingCartItem = (item: ShoppingCartItem.ShoppingCartItem): ShoppingCartItemInput =>
  take(item, 'count', 'itemId', 'itemType', 'amount', 'details') as ShoppingCartItemInput;
